import { render, staticRenderFns } from "./ComponentReference.vue?vue&type=template&id=4ddf65ff&scoped=true&"
import script from "./ComponentReference.vue?vue&type=script&lang=js&"
export * from "./ComponentReference.vue?vue&type=script&lang=js&"
import style0 from "./ComponentReference.vue?vue&type=style&index=0&id=4ddf65ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf65ff",
  null
  
)

export default component.exports